import './dropdown-sustainability.css';

export default (element, data) => {};